"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularLegendLayout = void 0;
const react_1 = __importDefault(require("react"));
require("./types");
exports.CircularLegendLayout = react_1.default.memo(({ size, children }) => {
    return (react_1.default.createElement("div", { style: {
            position: 'relative',
            left: 0,
            top: `${-size}px`,
            display: 'table',
            width: `${size}px`,
            height: `${size}px`,
            overflow: 'hidden',
        } },
        react_1.default.createElement("div", { style: { display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' } }, children)));
});
//# sourceMappingURL=CircularLegendLayout.js.map